import { BrokeragePostResponse } from '@lio/api-types';
import { brokerageKeys } from '@services/brokerage/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useDeactivateBrokerage = ({ brokerageId }: { brokerageId?: string }) => {
  const queryClient = useQueryClient();
  const client = useClient();
  const mutationFn = () => client.delete(`brokerage/${brokerageId}`).json<BrokeragePostResponse>();

  const result = useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [...brokerageKeys.brokerage, { brokerageId }] });
      queryClient.invalidateQueries({ queryKey: brokerageKeys.search });
    },
  });

  return { ...result, deactivateBrokerage: result.mutateAsync };
};
